__webpack_require__.p = "/waterfall-poker/";